import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

//Account JOB Management
import {
  ADD_TEMPLATE,
  DELETE_TEMPLATE,
  EDIT_TEMPLATE,
  GET_TEMPLATE,
  TEMPLATE_DETAILS,
  TEMPLATE_PREVIEW,
  GET_TEMPLATE_DATA,
} from "./actionTypes";
import {
  templateDetailsSuccess,
  templateDetailsFailed,
  addTemplateSuccess,
  addTemplateFailed,
  editTemplateSuccess,
  editTemplateFailed,
  getTemplateDetailSuccess,
  getTemplateDetailFailed,
  deleteTemplateSuccess,
  deleteTemplateFailed,
  getTemplatePreviewSuccess,
  getTemplatePreviewFailed,
  getTemplateDataSuccess,
  getTemplateDataFail,
} from "./actions";

import {
  getCall,
  postCall,
  putCall,
  deleteCall,
} from "../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";

function* getTemplateDetails(request) {
  try {
    var responsJSON = yield call(
      getCall,
      constClass.REST_API_TEMPLATE_LIST + request.payload,
    );
    yield put(templateDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(templateDetailsFailed(error));
  }
}

function* addTemplate(request) {
  try {
    var responsJSON = yield call(
      postCall,
      constClass.REST_API_TEMPLATE,
      request.payload,
    );
    yield put(addTemplateSuccess(responsJSON));
  } catch (error) {
    yield put(addTemplateFailed(error));
  }
}

function* editTemplate(request) {
  try {
    var responsJSON = yield call(
      putCall,
      constClass.REST_API_TEMPLATE,
      request.payload,
    );
    yield put(editTemplateSuccess(responsJSON));
  } catch (error) {
    yield put(editTemplateFailed(error));
  }
}

function* getTemplate(request) {
  try {
    var responsJSON = yield call(
      getCall,
      constClass.REST_API_GET_TEMPLATE + request.payload,
    );
    yield put(getTemplateDetailSuccess(responsJSON));
  } catch (error) {
    yield put(getTemplateDetailFailed(error));
  }
}

function* getDelete(request) {
  try {
    var responsJSON = yield call(
      deleteCall,
      constClass.REST_API_GET_TEMPLATE + request.payload,
    );
    yield put(deleteTemplateSuccess(responsJSON));
  } catch (error) {
    yield put(deleteTemplateFailed(error));
  }
}

function* getTemplatePreview(request) {
  try {
    console.log("=== PREVIEW SAGA ===");
    console.log("Request payload:", request.payload);

    if (!request.payload) {
      console.error("No payload in preview request");
      yield put(getTemplatePreviewFailed("No preview data provided"));
      return;
    }

    if (!request.payload.htmlTemplateData && !request.payload.id) {
      console.error("Missing htmlTemplateData and id");
      yield put(getTemplatePreviewFailed("Missing template data or ID"));
      return;
    }

    console.log("Calling API:", constClass.REST_API_TEMPLATE_PREVIEW);
    console.log("With payload keys:", Object.keys(request.payload));

    var responseJSON = yield call(
      postCall,
      constClass.REST_API_TEMPLATE_PREVIEW,
      request.payload,
    );

    console.log("API Response:", responseJSON);

    if (responseJSON && responseJSON.pdfTemplateData) {
      yield put(getTemplatePreviewSuccess(responseJSON));
    } else {
      console.error("Invalid response format:", responseJSON);
      yield put(getTemplatePreviewFailed("Invalid response from server"));
    }
  } catch (error) {
    console.error("=== PREVIEW SAGA ERROR ===");
    console.error("Error:", error);
    console.error("Error type:", typeof error);
    console.error("Error string:", String(error));
    yield put(getTemplatePreviewFailed(error));
  }
}

function* getTemplateDataHandler(id) {
  try {
    let responsJSON = yield call(getCall, constClass.REST_API_TEMPLATE_SAMPLE);
    yield put(getTemplateDataSuccess(responsJSON));
  } catch (error) {
    yield put(getTemplateDataFail(error));
  }
}

export function* watchTemplateConfiguration() {
  yield takeLatest(TEMPLATE_DETAILS, getTemplateDetails);
  yield takeLatest(ADD_TEMPLATE, addTemplate);
  yield takeLatest(EDIT_TEMPLATE, editTemplate);
  yield takeLatest(GET_TEMPLATE, getTemplate);
  yield takeLatest(DELETE_TEMPLATE, getDelete);
  yield takeLatest(TEMPLATE_PREVIEW, getTemplatePreview);
  yield takeEvery(GET_TEMPLATE_DATA, getTemplateDataHandler);
}

function* templateConfigurationSaga() {
  yield all([fork(watchTemplateConfiguration)]);
}
export default templateConfigurationSaga;
